import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function usePrivacyMode() {
  const route = useRoute()
  const router = useRouter()

  const isBlurred = computed(() => route.query.blur === '1')

  function toggleBlur() {
    const newQuery = { ...route.query }
    if (isBlurred.value) {
      delete newQuery.blur
    } else {
      newQuery.blur = '1'
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    router.replace({ query: newQuery })
  }

  return { isBlurred, toggleBlur }
}
